var $ = require("./lib/qsa")
var track = require("./lib/tracking");

var imageView = require("./views/imageView");
var textView = require("./views/textView");
// var graphicView = require("./views/graphicView"); //look in abu naser for example

require("./video"); 
require("./analytics");


// setup graphics here
// require("./graphic.js");

var slides = $(".sequence .slide").reverse();
var autoplayWrapper = $.one(".a11y-controls");

var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

var completion = 0;

if (false) "play canplay canplaythrough ended stalled waiting suspend".split(" ").forEach(e => {
  $("video").forEach(v => v.addEventListener(e, console.log));
});

// handle NPR One
var here = new URL(window.location.href);
var renderPlatform = here.searchParams.get("renderPlatform");
var isOne = renderPlatform && renderPlatform.match(/nprone/i);
if (isOne) {
  document.body.classList.add("nprone");
}

var handler;

var handlers = {
  // graphic: new graphicView(),
  image: new imageView(),
  video: new imageView(),
  text: new textView()
};

var active = null;
var previous = null;

var activateSlide = function(slide, slideNumber) {  
  // skip if already in the slide
  if (active == slide) return;
  
  // If we changed block type, let the previous director leave
  if (handler) {
    handler.exit(active);
  }

  var currType = slide.dataset.type || "image";
  handler = handlers[currType];
  handler.enter(slide);

  previous = active;

  active = slide;

  // force video playback
  if (!isOne) $("video[autoplay]", slide).forEach(v => {
    v.currentTime = 1;
    v.play();
  });

  // lazy-load neighboring slides
  var neighbors = [-1, 0, 1, 2];
  var all = $(".sequence .slide");
  var index = all.indexOf(slide);

  var isBackwards = index < all.indexOf(previous) ? true : false;

  neighbors.forEach(function(offset,i) {
    var neighbor = all[index + offset];
    if (!neighbor) return;
    var nextType = neighbor.dataset.type || "image";
    var neighborHandler = handlers[nextType];
    
    // not sure what needs to be passed to this handler....lots in the other one.
    neighborHandler.preload(neighbor)
    
  })
}

var onScroll = function() {
  for (var i = 0; i < slides.length; i++) {
    var slide = slides[i];    
    var bounds = slide.getBoundingClientRect();
    if (bounds.top < window.innerHeight * .9 && bounds.bottom > 0) {
      var complete = ((slides.length - i) / slides.length * 100) | 0;
      if (complete > completion) {
        completion = complete;
        track("completion", completion + "%");
      }
      return activateSlide(slide);
    }
  }
}

document.body.classList.add("boot-complete");
window.addEventListener("scroll", onScroll);
onScroll();



// link tracking
var trackLink = function() {
  var action = this.dataset.track;
  var label = this.dataset.label;
  track(action, label);
};
$("[data-track]").forEach(el => el.addEventListener("click", trackLink));

var oldonload = window.onload;

window.onload = (typeof window.onload != 'function') ? tp.experience.execute() : function() { oldonload(); tp.experience.execute(); };